<template>
  <v-app color="#F0F0F0">
    <v-content class="grey lighten-2">
      <LoginForm />
    </v-content>
  </v-app>
</template>

<script>
// @ is an alias to /src
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "Home",
  components: {
    LoginForm
  }
};
</script>
